import React, { useState } from 'react';

import { Skeleton } from '../Skeleton';
import { isMobile } from 'react-device-detect';

const FeaturedLoader = () => {
  return (
    <>
      <div className={`clinicalFeaturedSlide shadow position-relative overflow-y-visible`}>
        <div className="w-100 clinicalFeaturedMain d-flex flex-wrap flex-md-row-reverse align-items-center position-relative overflow-hidden h-auto bg-white">
          <div
            className="col-xl-8 col-lg-7 col-md-7 col-12 clinicalFeaturedRight"
            style={{ height: isMobile ? '200px' : '400px' }}
          >
            <Skeleton variant="rectangle" width="100%" height={'100%'} />
          </div>
          <div className="col-xl-4 col-lg-5 col-md-5 col-12 clinicalFeaturedLeft text-start p-3 p-md-4 pt-md-70 px-lg-20 pb-5 pb-md-5 position-relative">
            <Skeleton variant="text" width={100} height={25} />
            <h2 className="fs-3 text-black fw-medium mb-2 cursorPointer gtm_cl_clinical_videos_landing_featured_card">
              <Skeleton variant="text" width="90%" height={25} />
            </h2>
            <Skeleton variant="text" width="70%" height={25} />
            <div className="w-100 clinicalFeaturedDoctor mt-3 mb-20">
              <div className="clinicalFeaturedDoctorBox text-start">
                <div className="w-100 clinicalFeaturedDoctorBoxIn pe-4 d-flex justify-content-between align-items-center">
                  <div className="clinicalFeaturedDoctorPic position-relative overflow-hidden border border-white rounded-circle">
                    <Skeleton
                      variant="circular"
                      width="100%"
                      height="100%"
                      className="object-fit-cover w-100 h-100 float-start"
                    />
                  </div>
                  <div className="clinicalFeaturedDoctorContent ps-3">
                    <h4 className="text-black fs-4 fw-medium gtm_cl_clinical_videos_landing_featured_card">
                      <Skeleton variant="text" width="90%" height={25} />
                    </h4>
                    <Skeleton variant="text" width="30%" height={25} />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex">
              <Skeleton variant="rounded" width={30} height={30} className="me-3" />
              <Skeleton variant="rounded" width={90} height={30} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeaturedLoader;
